import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled", "onClick", "task"];
import { useState } from 'react';
import { LockedIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageLimitPopover from './UsageLimitPopover';
import { usePortalContactsLimit } from '../../../hooks/portalContacts';
import { useTaskLink } from '../../../hooks/hub';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreateContactButton = _ref => {
  let {
      children,
      disabled,
      onClick,
      task
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    link,
    id,
    key,
    handholdingEnabled,
    handholdingGroupKeyOverride,
    handholdingSource
  } = task;
  const [isUsageLimitPopoverOpen, setIsUsageLimitPopoverOpen] = useState(false);
  const {
    isWithinLimit,
    numberOfContacts,
    contactsLimit
  } = usePortalContactsLimit();
  const taskLink = useTaskLink(link, id, handholdingEnabled, handholdingGroupKeyOverride, handholdingSource);
  if (isWithinLimit) {
    return /*#__PURE__*/_jsx(Button, Object.assign({
      disabled: disabled,
      href: taskLink,
      onClick: onClick
    }, buttonProps, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(UsageLimitPopover, {
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.contacts.description"
    }),
    onClose: () => setIsUsageLimitPopoverOpen(false),
    open: isUsageLimitPopoverOpen,
    planLimitLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.contacts.planLimit",
      options: {
        limitNumber: contactsLimit
      }
    }),
    planUsageLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.contacts.planUsage",
      options: {
        usedNumber: numberOfContacts,
        limitNumber: contactsLimit
      }
    }),
    taskKey: key,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.contacts.title"
    }),
    upgradeCta: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.contacts.upgradeCta"
    }),
    upgradeKey: "import-export-crm-contacts-limit",
    usageCurrent: numberOfContacts,
    usageLimit: contactsLimit,
    children: /*#__PURE__*/_jsxs(Button, Object.assign({
      disabled: disabled,
      onClick: event => {
        if (typeof onClick === 'function') {
          onClick(event);
        }
        event.preventDefault();
        setIsUsageLimitPopoverOpen(true);
      }
    }, buttonProps, {
      children: [/*#__PURE__*/_jsx(LockedIcon, {}), children]
    }))
  });
};
export default CreateContactButton;